document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('[data-torches-and-consumables-container]');

  if (containers.length) {
    import(/* webpackChunkName: "tc" */ '/Features/Products/TorchesAndConsumables/js/torch-consumables.js').then(
      async (TorchConsumableComponent) => {
        containers.forEach((container) => {
          const torchconsumables = new TorchConsumableComponent.default();
          torchconsumables.init(container);
        });
      },
    );
  }
});
